import axios from 'axios'
import config from './config.js'
const csp4Config = config()
const baseObj = {
  baseURL: `${csp4Config.url}/`,
  withCredentials: false,
  headers: {
    'x-clientid': csp4Config.xClientid
  },
}

export default {
  /**
   * Make an api call to the server. Token in local storage is required
   */
  Api() {
    return axios.create(baseObj)
  },
  /**
   * Check if server is available
   */
  ping() {
    this.Api().get('')
      .then(response => response.status === 200)
  },
  getLocationInfo(storeID) {
    return this.Api().get(`core/location?storeID=${storeID}`)
      .then(response => {
        if (response && response.data) {
          console.log('response.data', response.data)
          return response.data.data
        }
      }).catch(error => {
        return null
      })
  },
}
